module.exports = __webpack_public_path__ + "static/media/addcategory-screenshot.4aaf4a11.png";